import OfficeUserShow from './concerns/OfficeUserShow'
import ChevronToggle from '../components/ChevronToggle'
import Bookmarkable from '../components/Bookmarkable'
import FroalaEditor from "../components/editor/FroalaEditor"

class PublicationJobsArticleJobs {
  constructor(params) {
    this.params = params
  }

  index() {
    new Bookmarkable();
  }

  show() {
    const role = this.params.role
    if (role == "editor" || role == "managing_editor") {
      this.bindRichTextEditor()
      if ($('.js-last-article-modal').length) {
        this.bindLastArticleModal()
      }
    } else {
      new OfficeUserShow();
    }
    new ChevronToggle();
  }

  bindRichTextEditor() {
    this.richTextEditor = new FroalaEditor();
    this.richTextEditor.enableTextTransformPlugin();
    this.richTextEditor.init();
  }

  bindLastArticleModal() {
    N2.bindHandler('click', '.js-last-article-show-modal', (evt) => {
      evt.preventDefault()
      $('.js-last-article-modal').modal()
      $('.modal-backdrop').addClass('in')

      // if no articles have been flagged but this last one has -
      // change the assignment text
      let pubStatus;
      let flagCount = $('.js-flag-count').data('flagCount');
      const $nextAssignment = $('.js-next-assignment');
      const form = evt.currentTarget.form;
      const reviewType = $(form).data('review');

      if (flagCount == 1 && $(form).data('isFlagged')) {
        // For in_edit_review when we are on the last flagged
        // article - regardless of what we do (reject/or approve)
        // it needs to move on to design
        pubStatus = this.nextPubStatus($nextAssignment, reviewType)
      } else if (flagCount > 0 ) {
        $nextAssignment.text('EDITING REVIEW')
        pubStatus = "edit_review"
      } else if (flagCount == 0 && evt.target.value == "edit_review") {
        $nextAssignment.text('EDITING REVIEW')
        pubStatus = "edit_review"
      } else {
        pubStatus = this.nextPubStatus($nextAssignment, reviewType)
      }
      $('<input>').attr({type: 'hidden', name: 'publication_job_status', value: `${pubStatus}`}).appendTo(form)
      // get off the event so it doesn't propogate multiple times if modal is cancelled
      N2.offHandle('click', '.js-submit-article', this.submitJob.bind(evt))
      // listen to the modal `GOT IT` event
      N2.handle('click', '.js-submit-article', this.submitJob.bind(evt))
    });
  }

  submitJob() {
    $(this.target).removeClass('js-last-article-show-modal')
    $(this.target).click()
  }

  nextPubStatus(assignment, reviewType) {
    assignment.text('DESIGN')
    return "building_pub"
  }
}

export default PublicationJobsArticleJobs
